import React from 'react';
import ReactDOM from 'react-dom';

// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

// project imports
import { store, persister } from './store';
import * as serviceWorker from './serviceWorker';
import App from './App';
import config from './config';

// style + assets
import './assets/scss/style.scss';

//-----------------------|| REACT DOM RENDER  ||-----------------------//

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persister}>
            <BrowserRouter basename={config.basename}>
                <App />
            </BrowserRouter>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);

// PWA: registra o service worker, permitindo instalar o app no celular e
// abrir mais rápido. Uma versão nova só passa a valer depois que o usuário
// fechar todas as abas/telas do app e abrir de novo (comportamento padrão
// do Workbox/CRA) - de propósito, pra não recarregar a tela sozinho no meio
// de uma conversa em andamento.
serviceWorker.register();
